<nz-card class="cwt-form-card-{{status || 'default'}}" [nzTitle]="title" [nzExtra]="extraTemplate">
    <ng-content></ng-content>
</nz-card>

<ng-template #extraTemplate>
    <span *nzStringTemplateOutlet="(innerTip || extra); context: { $implicit: validateControl }; let extraStr">{{extraStr}}</span>
</ng-template>